import Vue from 'vue'

import router from './router/index'
import store from './store/index'
import model from './model/index'
import modelDirectives from './model/utils/directives'
Vue.use(modelDirectives)

import { echo } from './services/echo'
import { axios } from './services/axios'
import axiosTasks from './services/axios-tasks'
import axiosErrorNotifier from './services/axios-error-notifier'

import nexus from '@db2b/nexus-js'
import vds from 'vue-data-sync'
import vdsEchoDriver from 'vue-data-sync/drivers/laravel-echo-driver'

import moment from 'moment'
import 'moment/locale/fr'
import vueMoment from 'vue-moment'
// Vue.use(vueMoment) // TODO : Check why if we init vue moment it crash the app

import ElementUI from 'element-ui'
import locale from 'element-ui/lib/locale/lang/fr'
locale.el.datepicker.month9 = 'Sept.'
locale.el.datepicker.month11 = 'Nov.'
locale.el.datepicker.month12 = 'Dec.'
import '../../../theme/index.css'
Vue.use(ElementUI, { locale })

import VueHighcharts from 'vue-highcharts'
Vue.use(VueHighcharts)

import timetable from 'vue-timetable'
Vue.use(timetable)

export default class {
  constructor (keystone, options) {
    this.config = keystone

    // Setup global elements instances
    this.instances = {}
    this.instances.store = store.get()
    this.instances.router = router.get(this.instances.store)

    // Register axios handlers
    axiosTasks.watch(axios, this.instances.store)
    axiosErrorNotifier.watch(axios)

    // Setup Echo / Nexus / Vue Data Sync
    Vue.use(nexus, { axios, echo, vds })

    Vue.use(vds, {
      driver: new vdsEchoDriver({
        echo: echo,
        options: {
          debug: true
        }
      })
    })

    // Make Vue aliases
    Vue.prototype.keystone = this
    Vue.prototype.moment = moment
    Vue.prototype.$http = axios
    Vue.prototype.$model = model
    Vue.prototype.$gnotify = window.toastr
    Vue.prototype.$gnotify.options.positionClass = 'toast-bottom-full-width'

    // Make global aliases
    window.user = () => {
      return this.instances.store.getters['users/current']
    }
  }

  router () {
    return this.instances.router
  }

  store () {
    return this.instances.store
  }
}



// WEBPACK FOOTER //
// ./libs/@db2b/keystone/index.js